import React, {useContext, useState} from 'react';
import {Context} from "../store/reducer";

/**
 * 不動産APIの注釈を表示するポップアップ
 * @returns {false|JSX.Element}
 * @constructor
 */
const Component = ({ optionId }) => {
    
    const { state, dispatch } = useContext(Context);

    /**
     * 閉じる場合はフラグをtrueにする。
     */
    const closeModal = () => {
        dispatch({
            type    : 'SET_IS_EXPLANATION_POPUP_OPENED',
            category: optionId,
            payload: false
        })
    }
    
    const setContent = (id) => {
        
        if (id === "vis_98_3") {

            // 学校 
            return (
              <>

                <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>小学校、中学校、中等教育学校、高等学校、高等専門学校、短期大学、大学、特別支援学校、義務教育学校、各種学校、専修学校を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している学校の情報は、「国土数値情報（学校）」を原典としています。原典データ作成時点の情報であり、最新の情報とは異なる場合があります。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（学校）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和３年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
   
              </>
            );
        } else if (id === "vis_98_14") {

            // 幼稚園、保育園
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>幼稚園、幼保連携型認定こども園、保育所などを表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している幼稚園・保育園等の情報は、「国土数値情報（学校）」及び「国土数値情報（福祉施設）」を原典としています。
                        原典データ作成時点の情報であり、最新の情報とは異なる場合があります。</p>
                    </div>

                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（学校）」及び「国土数値情報（福祉施設）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和３年度作成）</p>
                    </div>

                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>

                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_19") {

            // 医療機関
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>医療施設のうち、「病院」「診療所」「歯科診療所」（休止中の施設、企業内の施設等を含みます。）を表示します。ただし、巡回のみの医療施設は含めておりません。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している医療機関の情報は、「国土数値情報（医療機関）」を原典としています。原典データ作成時点の情報であり、最新の情報とは異なる場合があります。診療科目の表記については、原典資料での記載に由来する略称表記となっている箇所があります。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（医療機関）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和２年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_22") {

            // 福祉施設
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>高齢者福祉、障がい者福祉、児童福祉に関する施設を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している福祉施設の情報は、「国土数値情報（福祉施設）」を原典としています。原典データ作成時点の情報であり、最新の情報とは異なる場合があります。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（福祉施設）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和３年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_29") {

            // 図書館
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>図書館を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している図書館の情報は、「国土数値情報（文化施設）」を原典としています。原典データ作成時点の情報であり、最新の情報とは異なる場合があります。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（文化施設）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：平成25年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_30") {

            // 役場、公共施設
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>市区町村役場及びそれらの支所、出張所、連絡所等、公立公民館、集会所等を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している公共施設の情報は、「国土数値情報（市町村役場等及び公的集会施設）」を原典としています。原典データ作成時点の情報であり、最新の情報とは異なる場合があります。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（市町村役場等及び公的集会施設）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和４年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_32") {

            // 駅
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>鉄道事業者から収集した、各駅ごとの１日あたり乗降客数を表示します</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している駅（駅別乗降客数）の情報は、「国土数値情報（駅別乗降客数）」を原典としています。原典データ作成時点の情報であり、最新の情報とは異なる場合があります。駅に同一運営会社で複数路線ある場合、任意の路線に乗降客数が集約されています。（ただしＪＲの場合は在来線と新幹線ごとに乗降客数が集約されています。）</p>
                    </div>

                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（駅別乗降客数）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和４年度作成）</p>
                    </div>

                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>

                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_35") {

            // 不動産取引価格情報
            return (
                <>
                  <section class="u-pb-xs">
                    <h4 class="u-fs-14 u-pb-xxs">＜不動産取引価格情報＞</h4>
                    <p class="u-pb-xs u-lh-sm">国土交通省において不動産の取引当事者を対象としたアンケート調査を実施し、収集した情報をもとに、売買物件が容易に特定できないよう加工した上で、取引に関する情報（取引価格、土地の面積・形状など）について、四半期ごとに公表された情報です。なお、公表する価格については数値の丸め以外は一切補正は行われておりません。詳細は不動産取引価格情報提供制度をご確認ください。</p>
                    <div class="u-pb-xs">
                        <h5>【データの出典・整備時期】</h5>
                        <p class="u-lh-sm">国土交通省が作成したものを不動産情報ライブラリ（国土交通省）から取得しています。
                        整備時期は四半期に一回（4月・7月・10月・1月）です。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5>【表示される大きさ】</h5>
                        <p class="u-lh-sm">
                            <span class="u-bold">行政区画</span>：広域・県・市・町・大字・丁目・詳細<br />
                            <span class="u-bold">駅</span>：市・町・大字・丁目・詳細
                        </p>
                    </div>
                </section>
                <section class="u-pb-xs">
                    <h4 class="u-fs-14 u-pb-xxs">＜成約価格情報＞</h4>
                    <p class="u-pb-xs u-lh-sm">指定流通機構（レインズ）保有の不動産取引価格情報を、国土交通省が個別の不動産取引が特定できないよう加工し、消費者向け不動産取引情報サービスである、「レインズ・マーケット・インフォメーション」（RMI）にて公表されている情報です。なお、マンション及び一戸建ての不動産取引価格（成約価格）については、統計情報としての正確性に配慮した絞り込みを行った上で、個別の不動産取引が特定できないように加工し提供されております。</p>
                    <div class="u-pb-xs">
                        <h5>【データの出典・整備時期】</h5>
                        <p class="u-lh-sm">国土交通省が作成したものを不動産情報ライブラリ（国土交通省）から取得しています。
                        整備時期は四半期に一回（4月・7月・10月・1月）です。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5>【表示される大きさ】</h5>
                        <p class="u-lh-sm">行政区画：広域・県・市・町・大字・丁目・詳細<br />駅：市・町・大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_1") {

            // 小学校区
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>小学校及び市区町村の教育委員会等が指定する小学校別の一定の通学範囲となる「通学区域」を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している小学校区（小学校）の情報は、「国土数値情報（小学校区）」を原典としています。原典データ作成時点の情報であり、最新の情報とは異なる場合があります。また、一部、推定による直線的な境界線やポリゴンの重複等が存在するほか、資料の収集不可等のため通学区域の範囲データを作成していないところがあります。「私立小学校」「特別支援学校」「国立大学の附属小学校」等の一部の小学校については小学校区を設定していないため本データには収録されていません。ご利用にあたってはご注意ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（小学校区）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和３年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_2") {

            // 中学校区
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>中学校及び市区町村の教育委員会が指定する中学校別の一定の通学範囲である「通学区域」を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>このサイトで提供している中学校区（中学校）の情報は、「国土数値情報（中学校区）」を原典としています。原典データ作成時点の情報であり、最新の情報とは異なる場合があります。また、一部、推定による直線的な境界線やポリゴンの重複等が存在するほか、資料の収集不可等のため通学区域の範囲データを作成していないところがあります。「私立中学校」「特別支援学校」「国立大学の附属中学校」等の一部の中学校については中学校区を設定していないため本データには収録されていません。ご利用にあたってはご注意ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>「国土数値情報（中学校区）」（国土交通省）を加工して作成したものを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和３年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は国土数値情報ダウンロードサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_36" || id === "vis_98_37") {

            // 都市計画区域 または 区域区分
            return (
                <>
                  <section class="u-lh-sm">
                    <div class="u-pb-xs">
                        <h4 class="u-fs-14 u-pb-xxs">＜都市計画区域＞</h4>
                        <p>都市計画法に基づき都道府県等が定める都市計画区域を表示します。</p>
                    </div>
                    <div class="u-pb-sm">
                        <h4 class="u-fs-14 u-pb-xxs">＜区域区分＞</h4>
                        <p>都市計画法に基づき、都道府県等が定める都市計画区域の区域区分（市街化区域、市街化調整区域）を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <ul class="u-pb-xxs">
                        <li>・原典データ作成時点の情報であり、掲載されていない情報がある場合もあります。ご利用にあたってはご注意ください。</li>
                        <li>・掲載データに含まれる地区・地域の範囲は、概ねの位置を示すものであり、実際の都市計画の決定範囲等と異なる場合があります。</li>
                        </ul>
                        <p>詳細は都市計画決定GISデータのサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>国土交通省が整備する都市計画決定GISデータを不動産情報ライブラリ（国土交通省）から取得しています。
                        整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和４年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は都市計画決定GISデータのサイトをご確認ください。</p>
                        </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>市・町・大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_54") {

            // 高度利用地区
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>都市計画法に基づき市町が定める高度利用地区を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <ul>
                            <li>・原典データ作成時点の情報であり、掲載されていない情報がある場合もあります。ご利用にあたってはご注意ください。</li>
                            <li>・掲載データに含まれる地区・地域の範囲は、概ねの位置を示すものであり、実際の都市計画の決定範囲等と異なる場合があります。</li>
                        </ul>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>国土交通省が整備する都市計画決定GISデータを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和４年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は都市計画決定GISデータのサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>市・町・大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_55") {

            // 地区計画
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>都市計画法に基づき市町が定める地区計画の区域を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                    <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                    <ul>
                        <li>・原典データ作成時点の情報であり、掲載されていない情報がある場合もあります。ご利用にあたってはご注意ください。</li>
                        <li>・掲載データに含まれる地区・地域の範囲は、概ねの位置を示すものであり、実際の都市計画の決定範囲等と異なる場合があります。</li>
                    </ul>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>国土交通省が整備する都市計画決定GISデータを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和４年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は都市計画決定GISデータのサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>市・町・大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_56") {

            // 立地適正化計画
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p class="u-pb-xxs">都市再生特別措置法に基づき市町が定める立地適正化計画における居住誘導区域（※１）及び都市機能誘導区域（※２）を表示します。</p>
                        <p class="u-pb-xxs"><span class="u-bold">※１ 居住誘導区域</span><br />
                        人口密度を維持することにより、生活サービスやコミュニティが持続的に確保されるよう、居住を誘導すべき区域</p>
                        <p class="u-pb-xxs"><span class="u-bold">※２ 都市機能誘導区域</span><br />
                        医療・福祉・商業等の都市機能を都市の中心拠点や生活拠点に誘導し集約することにより、これらの各種サービスの効率的な提供を図る区域</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <ul>
                            <li>・原典データ作成時点の情報であり、掲載されていない情報がある場合もあります。ご利用にあたってはご注意ください。</li>
                            <li>・掲載データに含まれる地区・地域の範囲は、概ねの位置を示すものであり、実際の都市計画の決定範囲等と異なる場合があります。</li>
                        </ul>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>国土交通省が整備する都市計画決定GISデータを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和４年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は都市計画決定GISデータのサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>市・町・大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_39") {

            // 用途地域
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>都市計画法に基づき市町が定める用途地域を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <p>原典データ作成時点の情報であり、掲載されていない情報がある場合もあります。ご利用にあたってはご注意ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>国土交通省が整備する都市計画決定GISデータを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和４年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は都市計画決定GISデータのサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>市・町・大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        } else if (id === "vis_98_52") {

            // 防火地域及び準防火地域
            return (
                <>
                  <section class="u-lh-sm u-pb-xs">
                    <div class="u-pb-xs">
                        <p>都市計画法に基づき市町が定める防火地域及び準防火地域を表示します。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【利用時の注意事項】</h5>
                        <ul>
                            <li>・原典データ作成時点の情報であり、掲載されていない情報がある場合もあります。ご利用にあたってはご注意ください。</li>
                            <li>・掲載データに含まれる地区・地域の範囲は、概ねの位置を示すものであり、実際の都市計画の決定範囲等と異なる場合があります。</li>
                        </ul>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【データの出典・整備時期】</h5>
                        <p>国土交通省が整備する都市計画決定GISデータを不動産情報ライブラリ（国土交通省）から取得しています。整備時期は不動産情報ライブラリで提供されているデータに基づきます。（公開初期：令和４年度作成）</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【原典データの利用規約】</h5>
                        <p>詳細は都市計画決定GISデータのサイトをご確認ください。</p>
                    </div>
                    <div class="u-pb-xs">
                        <h5 class="u-pb-xxs">【表示される大きさ】</h5>
                        <p>市・町・大字・丁目・詳細</p>
                    </div>
                </section>
                </>
              );
        }

    }

    return (<>
        <div className="modal-first">
            <div className="modal-first-inner">

                {
                    setContent(optionId)
                }

                <p className="u-txt-c" onClick={closeModal}>
                    <span style={{"text-decoration": "underline", "cursor": "pointer"}}>閉じる</span>
                </p>
            </div>
        </div>
    </>);
}

export default Component
